import classNames from 'classnames'
import React, { useState, useRef, useCallback, useMemo } from 'react'
import { JSONFetcher, themeColor } from 'shared'
import { AccordionItemProps, AccordionItemChevronProps, AccordionItemCheckboxProps } from './types'

export const AccordionItem = ({ title, content, ...props }: AccordionItemProps) => {
  const [active, setActive] = useState(false)
  const contentRef = useRef<HTMLDivElement | null>(null)
  const activeClass = useMemo(() => (active && 'active') || '', [active])
  const height = useMemo(() => (active ? `${contentRef.current?.scrollHeight ?? 0}px` : '0px'), [active])
  const rotate = useMemo(
    () => (active ? 'module-accordeon-item__icon rotate' : 'module-accordeon-item__icon'),
    [active]
  )
  const linkText = useMemo(() => (active ? I18n.t('misc.less') : I18n.t('misc.more')), [active])

  const toggleAccordion = useCallback(() => {
    setActive((current) => !current)
  }, [])

  return (
    <div className="module-accordeon-item">
      <button className={`module-accordeon-item__container ${activeClass}`} onClick={toggleAccordion}>
        <label className="generic-custom-radio-field m-0">
          <Checkbox {...props} />
          <span className="module-accordeon-item__title">{title}</span>
        </label>
        <ChevronWithLink className={rotate} linkText={linkText} />
      </button>
      <div ref={contentRef} style={{ maxHeight: `${height}` }} className="module-accordeon-item__content">
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          style={{
            borderTop: `1px solid ${themeColor('gray-500')}`,
            padding: '16px 0 16px 0',
          }}
        />
      </div>
    </div>
  )
}

const ChevronWithLink = ({ direction, linkText, className, id }: AccordionItemChevronProps): JSX.Element => {
  const xPosition = direction === 'left' ? { left: -80 } : { right: -80 }

  return (
    <>
      <span className="link-text">{linkText}</span>
      <i id={id} className={classNames('hidden desktop:block fa fa-angle-down', className)} style={xPosition} />
    </>
  )
}

const Checkbox = ({ checkboxValue, checkboxUrl }: AccordionItemCheckboxProps): JSX.Element | null => {
  const [checked, setChecked] = useState(checkboxValue === 'true')

  const handleChange = useCallback(() => {
    if (!checkboxUrl) return
    JSONFetcher.put({
      url: checkboxUrl,
      success: () => {
        setChecked((checked) => !checked)
      },
    })
  }, [checkboxUrl])

  if (!checkboxUrl) return null

  return (
    <>
      <input type="checkbox" onChange={handleChange} checked={checked} />
      <span className="generic-custom-radio" style={{ display: 'inline-flex' }} />
    </>
  )
}
